// Module
var code = "<p>Label ce list</p> ";
// Exports
module.exports = code;